// Product Customizer Script
document.addEventListener('DOMContentLoaded', function() {
  const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbx1kJTziRJixsnd3voZkM-g7l-YlUu2cGfKynsIogzei5CayHe3ZOyiWn53suZIZwXO/exec';
  
  // Get elements
  const customizer = document.querySelector('.product-customizer');
  
  if (customizer) {
    const collapsibleHeader = customizer.querySelector('.collapsible-header');
    const collapsibleContent = customizer.querySelector('.collapsible-content');
    const customizationForm = document.getElementById('customization-form');
    const customizationSummary = customizer.querySelector('.customization-summary');
    const summaryContent = customizer.querySelector('.summary-content');
    const fileUpload = document.getElementById('file-upload');
    const fileList = document.getElementById('file-list');    // Toggle collapsible visibility with enhanced animation
    collapsibleHeader.addEventListener('click', () => {
      const isExpanded = collapsibleHeader.getAttribute('aria-expanded') === 'true';
      collapsibleHeader.setAttribute('aria-expanded', !isExpanded);
      
      // Add hover effect class
      collapsibleHeader.classList.add('animating');
      
      if (!isExpanded) {
        collapsibleContent.classList.add('active');
        // Trigger form container animation after content is visible
        setTimeout(() => {
          collapsibleContent.querySelector('.form-container').style.opacity = '1';
          collapsibleContent.querySelector('.form-container').style.transform = 'translateY(0)';
        }, 100);
      } else {
        collapsibleContent.querySelector('.form-container').style.opacity = '0';
        collapsibleContent.querySelector('.form-container').style.transform = 'translateY(-10px)';
        setTimeout(() => {
          collapsibleContent.classList.remove('active');
          customizationForm.reset();
          fileList.innerHTML = '';
          customizationForm.style.display = 'block';
          customizationSummary.style.display = 'none';
          
          // Remove any existing success message
          const existingSuccess = customizer.querySelector('.success-message');
          if (existingSuccess) {
            existingSuccess.remove();
          }
        }, 300);
      }
    });
    
    // Remove animating class after animation ends
    collapsibleHeader.addEventListener('transitionend', () => {
      collapsibleHeader.classList.remove('animating');
    });
    
    // Convert file to base64
    function getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
    
    // Handle file uploads with improved feedback
    if (fileUpload) {
      fileUpload.addEventListener('change', function() {
        fileList.innerHTML = '';
        
        if (this.files.length > 5) {
          alert('You can only upload a maximum of 5 files.');
          this.value = '';
          return;
        }
        
        Array.from(this.files).forEach((file, index) => {
          if (file.size > 100 * 1024 * 1024) {
            alert(`File ${file.name} exceeds the 100MB size limit.`);
            return;
          }
            const fileItem = document.createElement('div');
          fileItem.className = 'file-item';
          fileItem.style.opacity = '0';
          fileItem.style.transform = 'translateY(10px)';
          
          const fileName = document.createElement('span');
          fileName.className = 'file-name';
          fileName.textContent = file.name;
          
          const removeBtn = document.createElement('span');
          removeBtn.className = 'remove-file';
          removeBtn.innerHTML = '&times;';
          removeBtn.addEventListener('click', () => {
            fileItem.style.opacity = '0';
            fileItem.style.transform = 'translateY(10px)';
            setTimeout(() => fileItem.remove(), 300);
          });
          
          fileItem.appendChild(fileName);
          fileItem.appendChild(removeBtn);
          fileList.appendChild(fileItem);
            // Animate file item appearance with staggered delay
          setTimeout(() => {
            requestAnimationFrame(() => {
              fileItem.style.opacity = '1';
              fileItem.style.transform = 'translateY(0)';
            });
          }, index * 100); // Stagger animation by 100ms per item
        });
      });
    }
    
    // Handle form submission with enhanced animations
    customizationForm.addEventListener('submit', async function(event) {
      event.preventDefault();
      
      // Show loading state
      const submitBtn = this.querySelector('.submit-customization');
      const originalBtnText = submitBtn.innerHTML;
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      
      try {
        // Convert all images to base64
        const filePromises = Array.from(fileUpload.files).map(file => getBase64(file));
        const base64Images = await Promise.all(filePromises);
        
        // Prepare form data
        const formData = {
          timestamp: new Date().toISOString(),
          product_id: this.querySelector('[name="product_id"]').value,
          product_title: this.querySelector('[name="product_title"]').value,
          customer_name: this.querySelector('[name="customer_name"]').value,
          customer_phone: this.querySelector('[name="customer_phone"]').value,
          design_elements: this.querySelector('[name="design_elements"]').value,
          images: base64Images,
          terms_accepted: this.querySelector('[name="terms_accepted"]').checked ? 'Yes' : 'No'
        };

        // Send to Google Sheets/Drive
        const response = await fetch(GOOGLE_SCRIPT_URL, {
          method: 'POST',
          body: JSON.stringify(formData)
        });

        const result = await response.json();
        
        // Create and show success message with animation
        const successMessage = document.createElement('div');
        successMessage.className = 'success-message';
        successMessage.innerHTML = `
          <span class="checkmark"></span>
          <span>Your customization request has been submitted successfully!</span>
        `;
        
        // Fade out form
        customizationForm.style.opacity = '0';
        customizationForm.style.transform = 'translateY(-10px)';
        
        setTimeout(() => {
          customizationForm.style.display = 'none';
          customizationSummary.style.display = 'block';
          customizationSummary.appendChild(successMessage);
          
          // Display summary with image links and animations
          let summaryHTML = `
            <div class="summary-success">
              <h4>Thank you for letting us create your unique piece.</h4>
              <div class="summary-details">
                <p><strong>Name:</strong> ${formData.customer_name}</p>
                <p><strong>Phone:</strong> ${formData.customer_phone}</p>
          `;

          if (formData.design_elements) {
            summaryHTML += `<p><strong>Design Notes:</strong> ${formData.design_elements}</p>`;
          }

          if (result.imageUrls && result.imageUrls.length > 0) {
            summaryHTML += `
              <p><strong>Uploaded Files:</strong></p>
              <ul class="uploaded-files-list">
                ${result.imageUrls.map((url, index) => `
                  <li><a href="${url}" target="_blank">View File ${index + 1}</a></li>
                `).join('')}
              </ul>
            `;
          }

          summaryHTML += `
                <p class="summary-note">We're experiencing high demand — hang tight! We'll contact you within 12 - 24 Hours regarding your customization.</p>
              </div>
            </div>
          `;

          summaryContent.innerHTML = summaryHTML;
          
          // Show success message with animation
          setTimeout(() => {
            successMessage.classList.add('show');
          }, 100);
          
        }, 300);

      } catch (error) {
        console.error('Submission Error:', error);
        alert('There was an error submitting your customization. Please try again.');
      } finally {
        submitBtn.classList.remove('loading');
        submitBtn.innerHTML = originalBtnText;
        submitBtn.disabled = false;
      }
    });
  }
});